/**
 * Enum for DebitOrCreditEnum
 */
export enum DebitOrCreditEnum {
  "DEBIT" = "H",
  "CREDIT" = "S"
}
